import { OverlayModal } from '@pique/component';
import { openHistoryTipsModalAtom } from '@pique/core/atoms';
import { useEnableCloud } from '@pique/core/hooks/pique/use-enable-cloud';
import { useI18n } from '@pique/i18n';
import { useService, WorkspaceService } from '@toeverything/infra';
import { useAtom } from 'jotai';
import { useCallback } from 'react';

import TopSvg from './top-svg';

export const HistoryTipsModal = () => {
  const t = useI18n();
  const currentWorkspace = useService(WorkspaceService).workspace;
  const [open, setOpen] = useAtom(openHistoryTipsModalAtom);
  const confirmEnableCloud = useEnableCloud();

  const handleConfirm = useCallback(() => {
    setOpen(false);
    confirmEnableCloud(currentWorkspace);
  }, [confirmEnableCloud, currentWorkspace, setOpen]);

  return (
    <OverlayModal
      open={open}
      topImage={<TopSvg />}
      title={t['com.pique.history-vision.tips-modal.title']()}
      onOpenChange={setOpen}
      description={t['com.pique.history-vision.tips-modal.description']()}
      cancelText={t['com.pique.history-vision.tips-modal.cancel']()}
      confirmButtonOptions={{
        variant: 'primary',
      }}
      onConfirm={handleConfirm}
      confirmText={t['com.pique.history-vision.tips-modal.confirm']()}
    />
  );
};
